import { locale } from './locale';

export const environment = {
    production: true,
    locale: locale,
    recaptchaApiKey: '6Le7R5YsAAAAAAiFwFGyaDUTiz_NE8_wTmzqj0P3',
    gtagApiKey: '',
    ga4ApiKey: 'G-M1BG0VJLKN',
};
